import apiService from './api';
import type { ApiResponse } from '../types';
import type { PickForecast, WorkBucket, WorkKind, WorkStats } from '../types/nurseryWorkStats';

/** The nursery work summary (/nursery/work), nursery admin seat. */
const nurseryWorkStatsService = {
  /** Trees picked per person and farm, by hour, day or week. */
  async getWorkStats(filters: { from: string; to: string; bucket: WorkBucket; farm_id?: number | null; kind?: WorkKind }): Promise<ApiResponse<WorkStats>> {
    const params = new URLSearchParams({ kind: filters.kind ?? 'picking', from: filters.from, to: filters.to, bucket: filters.bucket });
    if (filters.farm_id) params.set('farm_id', String(filters.farm_id));
    return apiService.get(`/nursery/work-stats?${params.toString()}`);
  },

  /** Trees still to pick on loads due in the coming days, against recent pace. */
  async getPickForecast(filters: { days: number; farm_id?: number | null }): Promise<ApiResponse<PickForecast>> {
    const params = new URLSearchParams({ days: String(filters.days) });
    if (filters.farm_id) params.set('farm_id', String(filters.farm_id));
    return apiService.get(`/nursery/work-stats/forecast?${params.toString()}`);
  },
};

export default nurseryWorkStatsService;
